'use client';
import React from 'react';
import { getDefaultZIndex } from '../../core/utils/get-default-z-index/get-default-z-index.mjs';
import '@mantine/hooks';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../core/Box/Box.mjs';
import { factory } from '../../core/factory/factory.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import { ModalBody } from './ModalBody.mjs';
import { ModalCloseButton } from './ModalCloseButton.mjs';
import { ModalContent } from './ModalContent.mjs';
import { ModalHeader } from './ModalHeader.mjs';
import { ModalOverlay } from './ModalOverlay.mjs';
import { ModalRoot } from './ModalRoot.mjs';
import { ModalTitle } from './ModalTitle.mjs';
import classes from './Modal.module.css.mjs';

const defaultProps = {
  closeOnClickOutside: true,
  withinPortal: true,
  lockScroll: true,
  trapFocus: true,
  returnFocus: true,
  closeOnEscape: true,
  keepMounted: false,
  zIndex: getDefaultZIndex("modal"),
  transitionProps: { duration: 200, transition: "fade-down" },
  withOverlay: true,
  withCloseButton: true
};
const Modal = factory((_props, ref) => {
  const {
    title,
    withOverlay,
    overlayProps,
    withCloseButton,
    closeButtonProps,
    children,
    radius,
    ...others
  } = useProps("Modal", defaultProps, _props);
  const hasHeader = !!title || withCloseButton;
  return /* @__PURE__ */ React.createElement(ModalRoot, { ref, radius, ...others }, withOverlay && /* @__PURE__ */ React.createElement(ModalOverlay, { ...overlayProps }), /* @__PURE__ */ React.createElement(ModalContent, { radius }, hasHeader && /* @__PURE__ */ React.createElement(ModalHeader, null, title && /* @__PURE__ */ React.createElement(ModalTitle, null, title), withCloseButton && /* @__PURE__ */ React.createElement(ModalCloseButton, { ...closeButtonProps })), /* @__PURE__ */ React.createElement(ModalBody, null, children)));
});
Modal.classes = classes;
Modal.displayName = "@mantine/core/Modal";
Modal.Root = ModalRoot;
Modal.Overlay = ModalOverlay;
Modal.Content = ModalContent;
Modal.Body = ModalBody;
Modal.Header = ModalHeader;
Modal.Title = ModalTitle;
Modal.CloseButton = ModalCloseButton;

export { Modal };
//# sourceMappingURL=Modal.mjs.map
